import React from "react";
import { IDSBadge } from "@inera/ids-react";
import { getSubmissionStatusLabel } from "../../utils/submissionStatus";

const STATUS_BADGE_TYPES = {
  SUBMITTED: "info",
  IN_REVIEW: "attention",
  CLARIFIED: "secondary",
  APPROVED: "success",
  REJECTED: "error",
  DRAFT: "neutral",
  IN_CLARIFY: "attention",
};

function SubmissionStatusBadge({ status }) {
  const type = STATUS_BADGE_TYPES[status] || "neutral";
  return <IDSBadge type={type}>{getSubmissionStatusLabel(status)}</IDSBadge>;
}

export default SubmissionStatusBadge;
